import { render, staticRenderFns } from "./CreateAPassword.vue?vue&type=template&id=06e18ec6&scoped=true"
import script from "./CreateAPassword.vue?vue&type=script&lang=js"
export * from "./CreateAPassword.vue?vue&type=script&lang=js"
import style0 from "./CreateAPassword.vue?vue&type=style&index=0&id=06e18ec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e18ec6",
  null
  
)

export default component.exports